import React from 'react';
import {
  Box, Card, CardActionArea, CardContent, CardMedia,
  Typography
} from '@mui/material';
import { ProductResponse } from '../../type/web';
import { SelectedImage } from './types';

interface AnswerProductCardProps {
  product: ProductResponse;
  onOpenSmartCatalog: (pid: string) => void;
}

function AnswerProductCard(props: AnswerProductCardProps) {
  const { product, onOpenSmartCatalog } = props;

  // 这里需要一个简单的mime解析函数，或者从外部传入
  const media = product.mime ?? [];
  const thumbnail = media.length > 0 ? media[0].thumbnail : '';
  const name = product?.details?.descriptionShort?.['zh'] ?? ' ';

  return (
    <Card sx={{ maxWidth: 240, mb: 2 }}>
      <CardActionArea onClick={() => onOpenSmartCatalog(product.id)}>
        <CardMedia component='img'
          height='180'
          image={thumbnail}
          alt={name}
        />
        <CardContent>
          <Typography gutterBottom variant='body1'>
            {name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

interface QAImageItemProps {
  tid?: string;
  item: {
    type: 'image';
    id: number;
    question: SelectedImage;
    answer: ProductResponse[];
    done: boolean;
  };
  onOpenSmartCatalog: (pid: string) => void;
}

export default function QAImageItem(props: QAImageItemProps) {
  const { item, onOpenSmartCatalog } = props;
  const { question, answer = [], done } = item;
  const IsEmpty = done && answer.length === 0;

  return (
    <Box>
      <Box display='flex' flexDirection='row-reverse' mb={1}>
        <img src={question.preview} alt={question.name}
          width='120px'
          height='120px'
          style={{
            objectFit: 'contain',
            borderRadius: '12px',
            border: '1px solid #eee'
          }}
        />
      </Box>
      <Box mb={1}>
        {IsEmpty && <Typography>未找到相似产品</Typography>}
        {done && !IsEmpty && <Typography sx={{ mb: 1.5 }}>
          根据您提供的图片我们找到了以下相似的产品
        </Typography>}
        {(answer ?? []).map(product => <AnswerProductCard
          key={product.id}
          product={product}
          onOpenSmartCatalog={onOpenSmartCatalog}
        />)}
      </Box>
    </Box>
  );
}
